module.exports = __webpack_public_path__ + "media/embeds/icons/powered_by_white-d9b1deb72b2d1344cc6112a41ce16f7a.png";